import React from "react";
import { formatCurrency } from "../../helpers/estimateTotals";

export function ReportItemRows({ rows, variant = "print" }) {
  if (!rows?.length) return null;

  const prefix = variant === "print" ? "erp" : "er";

  return (
    <div>
      {rows.map((row, index) => (
        <div key={`${row.name}-${index}`} className={`${prefix}-item-row`}>
          <div className={`${prefix}-item-name`}>
            <div>{row.name}</div>
            {row.description && (
              <span className={`${prefix}-item-detail`}>{row.description}</span>
            )}
            {row.date && (
              <span className={`${prefix}-item-detail`}>{row.date}</span>
            )}
            {row.detail && (
              <span className={`${prefix}-item-detail`}>{row.detail}</span>
            )}
            {row.notes && (
              <span className={`${prefix}-item-detail`}>Notes: {row.notes}</span>
            )}
          </div>
          {row.amount != null && (
            <div className={`${prefix}-item-amount`}>
              {formatCurrency(row.amount)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
